module.exports = require('./lib/ponyfill');



//////////////////
// WEBPACK FOOTER
// ./~/symbol-observable/ponyfill.js
// module id = 292
// module chunks = 0